<!--
Displays opening times for a study space, if this has been provided.

@author cm359n

-->
<template>
  <div class="facilitylist">
      <span class="fac" :key="index" v-for="(icon, index) in icons">
      <FacilityIcon
          :faIconName="icon.fa"
          :assetImageName="icon.assets"
          :title="icon.title" />
      </span>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
//Components
import FacilityIcon from '@/components/spaces/FacilityIcon.vue'

//Composables
import {useStringUtil} from '@/composables/StringMethods.js'

const props = defineProps({
   list:Array
})

const {replaceWeirdChars} = useStringUtil()
const icons = ref([])

onMounted(() => {
  computeIcons()
})

function computeIcons () {
    const titlelist = {
      'byod': 'BYOD',
      'cafe': 'Cafe',
      'desktop': 'Desktop',
      'online': 'Online',
      'group': 'Group Study',
      'individual': 'Individual Study',
      'print': 'Printer',
      'wifi': 'Wi-fi'
    }
    // fontawesome icons here. the icons are in free-solid-svg-icons by default
    // if they aren't, make sure you include the relevant library in main.js
    // and specify the correct prefix before the icon name e.g. far:play-circle
    const falist = {
      'byod': 'laptop',
      'cafe': 'coffee',
      'desktop': 'desktop',
      'individual': 'user',
      'online': 'far:play-circle',
      'wifi': 'wifi',
      'print': 'print'
    }
    // any non-font-awesome icons we place in here
    // e.g. 'byod.svg' where the file should be located in src/assets/byod.png
    const assetlist = {
      'group': 'group.svg'
    }
    let iconlist = []
    if (typeof props.list !== 'undefined') {
      // careful. my hardcoded version has each as a string e.g. 'wifi'
      // ccws service is actually handing us each element as an object
      /*
      {
        "facilityCode": "wifi",
        "facilityDescription": "Wi-Fi"
      }
      */
      for (let f of props.list) {
        if (typeof f === 'object') {
          const facCode = replaceWeirdChars(f.facilityCode)
          const facDesc = replaceWeirdChars(f.facilityDescription)
          let facIcon = falist[facCode] ? {
            'fa': falist[facCode], 'title': facDesc
          } : {
            'assets': assetlist[facCode], 'title': facDesc
          }
          if (falist[facCode] && typeof falist[facCode] === 'undefined') {
            console.log('icon for facCode "' + facCode + '" not found')
          }
          if (!falist[facCode] && typeof assetlist[facCode] === 'undefined') {
            console.log('icon for facCode "' + facCode + '" not found')
          }

          iconlist.push(facIcon)
        } else { // my hardcoded list 'wifi', 'byod' etc....
          iconlist.push(falist[f] ? {
            'fa': falist[f], 'title': titlelist[f]
          } : {
            'assets': assetlist[f], 'title': titlelist[f]
          })
        }
      }
    }
    // sort 'em - we weren't given an order so alphabetical will have to do
    // leave them in the order the backend server sorted them
    /* iconlist.sort(function (a, b) {
      if (a.title > b.title) {
        return 1
      } else if (a.title < b.title) {
        return -1
      } else {
        return 0
      }
    }) */
    // and assign
    icons.value = iconlist
}
</script>

<style>
.facilitylist {
  line-height:13px;
}
.fac-title {
  margin-top:3px;
}
.fac {
  float: left;
  width: 60px;
  height: 60px;
  font-size: small;
  text-align: center;
  vertical-align: bottom;
  display: inline;
}
</style>
